import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES]: {
		url: '/company/:companyId/gps_sources/',
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE]: {
		url: '/company/:companyId/gps_sources/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE]: {
		url: '/company/:companyId/gps_sources/:gpsSourceId/',
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE]: {
		url: '/company/:companyId/gps_sources/:gpsSourceId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
